document.addEventListener("DOMContentLoaded", function() {
    if ($('.tabstyle-onpage-nav').length !== 0) {
        stickyOnPageNav();
        onPageScrollingEvents();
    }

    function stickyOnPageNav() {
        const indent = parseInt($('body').css('font-size'), 10); // 1rem;
        const nav = document.querySelector('.tabstyle-onpage-nav');
        const header = document.querySelector('.page-header');
        const headerHeight = header !== null ? header.offsetHeight : 0;
        const navOffset = (nav.getBoundingClientRect().top + window.scrollY) - headerHeight;

        $(window).scroll( function() {
            $(nav).toggleClass( 'sticky', $(window).scrollTop() >= navOffset + indent );
        });

        $(nav).toggleClass( 'sticky', $(window).scrollTop() >= navOffset + indent );
    }

    function onPageScrollingEvents() {
        const margin = 48; // the section's top margin
        const sections = document.querySelectorAll(".onpage-element-container > section[id]");
        const firstTop = sections.item(0).getBoundingClientRect().top + window.scrollY;

        const header = document.querySelector('.page-header');
        const headerHeight = header !== null ? header.offsetHeight : 0;
        const navHeight = $('.tabstyle-onpage-nav').outerHeight() - 16; // in fixed position it has only 1rem spacing to header

        $(window).scroll( function() {
            let scrollPos = window.scrollY + headerHeight + navHeight;

            sections.forEach(function(current)  {
                const sectionHeight = current.offsetHeight;
                const sectionTop = (current.getBoundingClientRect().top + window.scrollY);
                const sectionId = current.getAttribute("id");

                if (scrollPos <= (firstTop - margin)) {
                    const navLinks = document.querySelectorAll(".tabstyle-onpage-nav a.nav-link");
                    navLinks.forEach(function(element)  {
                        element.classList.remove("active");
                    });
                    navLinks.item(0).classList.add('active');
                }
                else if ((scrollPos > sectionTop - margin) && (scrollPos <= sectionTop + sectionHeight)) {
                    document.querySelector(".tabstyle-onpage-nav a.nav-link[href*=" + sectionId + "]").classList.add("active");
                } else {
                    document.querySelector(".tabstyle-onpage-nav a.nav-link[href*=" + sectionId + "]").classList.remove("active");
                }
            });
        });
    }

});
